import { FaceAgent } from 'mdi-material-ui'
import { FeatureCodes, moduleKeys } from 'src/components/common/featureData'

const redirectUrl = process.env.NEXT_PUBLIC_USER_REDIRECT_URL

export const corporateMenu = {
  [FeatureCodes.CES.corporateStudents]: {
    title: 'Corporate Student Application',
    icon: FaceAgent,
    path: `${redirectUrl}corporate/corporate-students/list`,
    badgeColor: 'error',
    module: moduleKeys.corporate
  },
  [FeatureCodes.CES.corporate]: {
    title: 'Corporate',
    icon: FaceAgent,
    path: `${redirectUrl}corporate/corporate/management`,
    badgeColor: 'error',
    module: moduleKeys.corporate
  },
  [FeatureCodes.CES.corporateGroup]: {
    title: 'Corporate Groups',
    icon: FaceAgent,
    path: `${redirectUrl}corporate/corporate-groups/list`,
    badgeColor: 'error',
    module: moduleKeys.corporate
  },
  [FeatureCodes.CES.corporateStudentManagement]: {
    title: 'Corporate Student Management',
    icon: FaceAgent,
    path: `${redirectUrl}corporate/corporate-students-management`,
    badgeColor: 'error',
    module: moduleKeys.corporate
  },
  [FeatureCodes.CES.projectManagement]: {
    title: 'Project Management',
    icon: FaceAgent,
    path: `${redirectUrl}corporate/project/management`,
    badgeColor: 'error',
    module: moduleKeys.corporate
  },
  [FeatureCodes.CES.corporateManager]: {
    title: 'Corporate Manager',
    icon: FaceAgent,
    path: `${redirectUrl}corporate/corporate-manager`,
    badgeColor: 'error',
    module: moduleKeys.corporate
  }
}
